import React, { useMemo } from 'react';
import ModalCore from './ModalCore';
import ActionButton from './ActionButton';
import { prefixCls } from '../constants';
import { Icon } from 'ui-library';
import { ICON_TYPE_CLOSE_SLIM } from 'ui-library/components/Icon';

const ConfirmModal = (props) => {
    const {
        close,
        okButtonProps,
        cancelButtonProps,
        okText = 'OK',
        cancelText = 'Cancel',
        visible,
        onCancel,
        afterClose,
        onOk,
        width = 380,
        title,
        content,
        className = '',
        triggerCancelOnClose = false,
        okCancel = true,
        okType = 'primary',
    } = props;

    const cancelButton = (okCancel && !!cancelText) && (
        <ActionButton
            actionFn={onCancel}
            closeModal={close}
            {...cancelButtonProps}

        >
            {cancelText}
        </ActionButton>
    );

    const closeIcon = useMemo(() => (<Icon type={ICON_TYPE_CLOSE_SLIM} size={20} />), []);

    return (
        <ModalCore
            visible={visible}
            prefixCls={prefixCls}
            className={`${className} ${prefixCls}-confirm has-radius`}
            onCancel={() => close({ triggerCancel: true })}
            afterClose={afterClose}
            width={width}
            transitionName="zoom"
            keyboard={false}
            maskClosable={false}
            closable
            borderRadius
            closeIcon={closeIcon}           
        >
            <div className={`${prefixCls}-confirm-body-wrapper`}>
                <div className={`${prefixCls}-confirm-body`}>
                    <div className="ModalHeader">
                        {title === undefined ? null : (
                            <div className={`${prefixCls}-title`}>{title}</div>
                        )}
                        <button
                            type="button"
                            className="ModalHeader__ModalClose"
                            aria-label="Close"
                            onClick={() => (close({ triggerCancel: triggerCancelOnClose }))}
                        >
                            {closeIcon}
                        </button>
                    </div>
                    <div className={`${prefixCls}-confirm-content`}>{content}</div>
                </div>                
                <div className={`${prefixCls}-confirm-btns`}>
                    <ActionButton
                        type={okType}
                        actionFn={onOk}
                        closeModal={close}
                        buttonProps={okButtonProps}
                    >
                        {okText}
                    </ActionButton>
                    {cancelButton}
                </div>
            </div>
        </ModalCore>
    );
};

export default ConfirmModal;
